import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { CreateEventError } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: CreateEventError;
  createEvent(request: Boundaries["createEvent"]["request"]): void;
}

function useCreateEvent(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCreateEventRequestPending),
    isRequestSuccess: useSelector(selector.isCreateEventRequestSuccess),
    isRequestFailure: useSelector(selector.isCreateEventRequestFailure),
    error: useSelector(selector.getCreateEventError)!,
    createEvent: core.createEvent,
  };
}

export { useCreateEvent };
